import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import GlobalReducer from "redux/reducers/globalSlice";
import signUpSliceReducer from "./reducers/signUpSlice";
import addServiceReducer from "./reducers/addServiceSlice";
import formsReducer from "./reducers/formsSlice";

const store = configureStore({
  reducer: {
    global: GlobalReducer,
    signup: signUpSliceReducer,
    addService: addServiceReducer,
    forms: formsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
